/*
 * Guillo Clothing — Pipeline Theme custom JS
 */
(function () {
  var fixReady = false;

  function initMobileStickyAtcFix() {
    if (fixReady) return;
    if (!document.querySelector('[data-section-type="product"]')) return;

    var atcBtn = document.querySelector('button[data-add-to-cart]');
    if (!atcBtn) return;

    fixReady = true;

    // On mobile, suppress the sticky product form wrapper while the main ATC
    // button is visible. Only reveal the sticky bar once user scrolls past it.
    var s = document.createElement('style');
    s.textContent =
      '@media (max-width: 768px) {' +
        'body.guillo-atc-visible [data-product-form-wrapper].is-sticky {' +
          'position: relative !important;' +
          'transform: none !important;' +
          'bottom: auto !important;' +
          'top: auto !important;' +
          'left: auto !important;' +
          'right: auto !important;' +
          'width: auto !important;' +
          'box-shadow: none !important;' +
        '}' +
      '}';
    document.head.appendChild(s);

    if (window.innerWidth <= 768) {
      document.body.classList.add('guillo-atc-visible');
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (window.innerWidth > 768) return;
        document.body.classList.toggle('guillo-atc-visible', entry.isIntersecting);
      });
    }, { threshold: 0.1 }).observe(atcBtn);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initMobileStickyAtcFix)
    : initMobileStickyAtcFix();

  setTimeout(initMobileStickyAtcFix, 500);
})();
